import { render, staticRenderFns } from "./faktury.vue?vue&type=template&id=263b3398&"
import script from "./faktury.vue?vue&type=script&lang=js&"
export * from "./faktury.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports